const KEY_COMPONENT_HEADER_CONFIG = "rg-header-config";

export function getCacheComponentHeaderConfig() {
    var config = getSessionStorageComponentConfig();
    return config;
}

export function setCacheComponentHeaderConfig(config) {
    if (config) {
        sessionStorage.setItem(KEY_COMPONENT_HEADER_CONFIG, JSON.stringify(config));
    } else {
        sessionStorage.removeItem(KEY_COMPONENT_HEADER_CONFIG);
    }
}

function getSessionStorageComponentConfig() {
    const dataStr = sessionStorage.getItem(KEY_COMPONENT_HEADER_CONFIG);
    try {
        return dataStr ? JSON.parse(dataStr) : null;
    } catch (e) {
        return null;
    }
}
